import React from 'react';
import './Library.css';
import '../Title/Title';
import Title from '../Title/Title';

export default class Library extends React.Component {
    render() {
        return (
            <div>
                {this.props.playlistLibrary.map(playlist => {
                return <Title 
                title={playlist.title} 
                key={playlist.id}
                id={playlist.id} 
                onTitleClick={this.props.onTitleClick}
                onDelete={this.props.onDelete}
                />
                }
                )
                }
                 
            </div>
        )
    }
}